export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#1F0040',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#D291FF',
  },
  {
    path: 'M343.7312 325.632h68.096l140.8 365.568h-68.608l-34.304-96.768h-145.92l-34.304 96.768h-66.048z m-22.528 220.16h111.616l-54.784-157.184h-1.536zM624.8192 573.952c0 41.472 22.528 78.336 71.168 78.336 33.792 0 54.272-14.848 64.512-44.032h55.296c-12.8 57.856-61.952 90.112-119.808 90.112-82.944 0-129.536-57.856-129.536-139.264 0-75.264 49.152-139.776 128-139.776 83.456 0 134.656 75.264 124.928 154.624z m136.192-38.4c-2.048-36.864-27.136-70.144-66.56-70.144-40.448 0-68.096 30.72-69.632 70.144z',
    fill: '#D291FF',
  },
]
